import { createFileRoute } from '@tanstack/react-router'

import { ProjectScreeningPage } from '@/modules/tools/bankruptcy'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/screening',
)({
  component: ProjectScreening,
})

function ProjectScreening() {
  const { slug } = Route.useParams()

  return <ProjectScreeningPage slug={slug} />
}
